<script>
  'use strict'

  import { tileX, tileY, _tileMap, _tilesCollections, _tilesCollectionFileName, _autoSaveFile } from "../store/store"

  const LOCALSTORAGE_KEY = 'maptilaz';
  let autoSavedFile = {};

  // ------------------------------------------------- 
  getFromLocalStorage();

  // -------------------------------------------------
  tileX.subscribe(value => $_autoSaveFile ? saveToLocalStorage('tileX', value) : '');
  tileY.subscribe(value => $_autoSaveFile ? saveToLocalStorage('tileY', value) : '');
  _tileMap.subscribe(value => $_autoSaveFile ? saveToLocalStorage('_tileMap', value) : '');
  _tilesCollections.subscribe(value => $_autoSaveFile ? saveToLocalStorage('_tilesCollections', value) : '');
  _tilesCollectionFileName.subscribe(value => $_autoSaveFile ? saveToLocalStorage('_tilesCollectionFileName', value) : '');


  // -------------------------------------------------
  function saveToLocalStorage(k, v) {
    autoSavedFile[k] = v;
    const saveToLocalStorage = JSON.stringify(autoSavedFile);
    localStorage.setItem(LOCALSTORAGE_KEY, saveToLocalStorage);
  }

  function getFromLocalStorage() {
    const fromLocalStorage = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY));
    if (fromLocalStorage) {
      restoreProject(fromLocalStorage);
    }
  }
  
  function autoDownloadFile (objectToDownload, filename = 'project.mptz') {
    const dataURI = encodeURIComponent(JSON.stringify(objectToDownload));

    const element = document.createElement('a');
    element.setAttribute('href', `data:text/json;charset=utf-8,${dataURI}`);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);

    return true;
  }

  function restoreProject(project) {
    tileX.set(project['tileX']);
    tileY.set(project['tileY']);
    _tilesCollections.set(project['_tilesCollections']);
    _tilesCollectionFileName.set(project['_tilesCollectionFileName']);
    _tileMap.set(project['_tileMap']);
  }

  export const saveProjectFileLocally = (projectName = 'untitled') => {
    projectName == '' ? 'untitled' : projectName; 
    const filename = `${projectName}-${Date.now()}.mptz`
    autoDownloadFile(autoSavedFile, filename);
  }
</script>